import { SubscriptionHistoryIndex } from "@Src/features/SubscriptionHistory/index"

export const SubscriptionHistory = () => {
    return (
        <>
            <div className="main-layout-container tw-flex-grow" style={{paddingTop:0}}>
                <SubscriptionHistoryIndex />
            </div>
        </>
    )
}